const DATE_TIME = new Intl.DateTimeFormat("sv-SE", { dateStyle: "short", timeStyle: "short" });
const DATE = new Intl.DateTimeFormat("sv-SE", { dateStyle: "short" });
const TIME = new Intl.DateTimeFormat("sv-SE", { timeStyle: "short" });

/** "2026-09-23 10:41" in the viewer's time zone, for an epoch-seconds value. */
export function formatDateTime(epoch: number): string {
  return DATE_TIME.format(new Date(epoch * 1000));
}

/** "2026-09-23" in the viewer's time zone. */
export function formatDate(epoch: number): string {
  return DATE.format(new Date(epoch * 1000));
}

/** "10:41" in the viewer's time zone. */
export function formatTime(epoch: number): string {
  return TIME.format(new Date(epoch * 1000));
}

/** An ISO timestamp from the BFF as "2026-09-23 10:41"; an unparsable value is returned as sent. */
export function formatIsoDateTime(iso: string): string {
  const ms = Date.parse(iso);
  return Number.isNaN(ms) ? iso : formatDateTime(ms / 1000);
}
